import { propertyMap } from 'model-mapper';
import { OrganizationalUnit } from './organizational-unit';

export class Cluster extends OrganizationalUnit {

  @propertyMap()
  public dummy: string;

}
